import React from "react";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";

// A React component that renders the controls bar on the map page. 
// It includes a calendar icon to open the date picker
// and a dropdown to select the time period (e.g., week, month).

const ControlsBar = ({
  isMobile,
  CalendarIcon,
  onOpenCalendar,
  selectedRangeLabel,
  setSelectedRangeLabel,
  sliderTicks,
  sliderIndex,
  setSliderIndex,
  t,
}) => {
  return (
    <div
      className="hidden lg:flex fixed top-20 right-0 z-40 flex-col justify-center
                 lg:flex-row lg:items-center lg:gap-4
                 bg-white/80 p-2 rounded-l-lg shadow-lg"
      style={{ width: "calc(50vw - 10px)" }}
    >
      {!isMobile && (
        <CalendarIcon
          onClick={onOpenCalendar}
          className="w-8 h-8 cursor-pointer hover:opacity-80 text-gray-700"
        />
      )}

      {!isMobile && (
        <div className="hidden lg:flex items-center gap-4 w-full">
          <DropdownButton
            id="RangeSelect"
            title={selectedRangeLabel}
            variant="primary"
            size="sm"
          >
            <Dropdown.Item onClick={() => setSelectedRangeLabel(t("map_page.time_periods.week"))}>
              {t("map_page.time_periods.week")}
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setSelectedRangeLabel(t("map_page.time_periods.month"))}>
              {t("map_page.time_periods.month")}
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setSelectedRangeLabel(t("map_page.time_periods.year"))}>
              {t("map_page.time_periods.year")}
            </Dropdown.Item>
          </DropdownButton>

          <div className="relative flex-1">
            <input
              type="range"
              min={0}
              max={Math.max(0, sliderTicks.length - 1)}
              step={1}
              value={sliderIndex}
              onChange={(e) => setSliderIndex(Number(e.target.value))}
              className="w-full appearance-none h-2 bg-gray-300 rounded-md"
            />
            <div className="flex justify-between mt-1 text-xs text-black">
              {sliderTicks.map((tick, i) => (
                <span key={i}>{tick.label}</span>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ControlsBar;
